import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, AfterContentInit } from '@angular/core';
import { Borrower } from 'app/models/dto/borrower.model';
import { BorrowerService } from 'app/services/borrower/borrower.service';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { SubscribeToCallNotificationChannels, SubscribeToNotificationChannels, UnsubscribeFromNotificationChannels } from 'app/store/notification/notification.actions';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { PusherService } from 'app/modules/shared/services/pusher.service';
import { environment } from 'environments/environment';
import { GoOnline } from 'app/store/lender-user/lender-user/lender-user.actions';
import { Router } from '@angular/router';
import { ActivityState } from 'app/store/activity/activity.state';
import { LatestActivitiesViewed } from 'app/store/activity/activity.actions';
import { INavTab } from 'app/modules/nav/models/nav-tab.interface';
import { PIPELINE_TABS, tabVisibleToUser } from 'app/modules/nav/nav-tabs';

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss'],
  standalone: false
})
export class GlobalHeaderComponent implements OnInit, OnDestroy, AfterContentInit {

  unreadNotifications$: Observable<number> = this.store.select(ActivityState.latestUnreadActivitiesCount);
  @Output() globalHeaderLoaded = new EventEmitter();
  @Output() notificationDrawerToggle = new EventEmitter<boolean>();
  @Output() cxDrawerToggle = new EventEmitter<boolean>();
  @Input() user: LenderUser;
  lenderUser: any;
  canSubmitCxInteractions: boolean;
  menuTabs: INavTab[] = [];

  constructor(
    private borrowerService: BorrowerService,
    private store: Store,
    private pusherService: PusherService,
    private router: Router
  ) {}

  ngOnInit() {
    this.subscribeToNotificationChannels();
    this.canSubmitCxInteractions = this.user?.team?.type?.includes('customer_service') || this.user?.team?.name?.includes('Test');
    this.menuTabs = PIPELINE_TABS.filter(tabVisibleToUser(this.user));
  }

  ngAfterContentInit(): void {
    this.globalHeaderLoaded.emit();
  }

  handleCxDrawer() {
    this.cxDrawerToggle.emit(true);
  }

  handleNotificationDrawer() {
    this.notificationDrawerToggle.emit(true);
    this.store.dispatch(new LatestActivitiesViewed());
  }

  subscribeToNotificationChannels() {
    this.store.dispatch(new SubscribeToNotificationChannels(this.user));
    this.store.dispatch(new SubscribeToCallNotificationChannels(this.user));
  }

  viewBorrower(borrower: Borrower) {
    if (!borrower.deleted) {
      this.router.navigate(['/borrower/', borrower.id]);
      return;
    }

    this.borrowerService.update(borrower.id, {
      deleted: false,
    }).pipe(take(1)).subscribe(() => {
      this.router.navigate(['/borrower/', borrower.id]);
    });
  }

  goOnline() {
    this.store.dispatch(new GoOnline(this.user.id));
  }

  handleMenuRoute(tab: INavTab) {
    this.router.navigate([tab.uri]);
  }

  ngOnDestroy(): void {
    this.pusherService.unsubscribeRaw(`LS-global-${environment.environment}-channel`);
    this.store.dispatch(new UnsubscribeFromNotificationChannels());
  }
}
